<p-toast position="top-right" key="common-toast"></p-toast>

<div [ngClass]="headerClass()">
  <div class="brand">
    <a class="menu-button" (click)="onMenuButtonClick($event)">
      <i class="pi pi-bars"></i>
    </a>
  </div>

  <ul class="topbar-menu">
    <li class="topbar-submenu">
      <a
        pTooltip="{{ generalTexts.notificationHelpText.label }}"
        tooltipPosition="bottom"
        [routerLink]="'/main/activity-manager'"
      >
        <app-badge
          type="icon"
          text="Notification"
          badgeNumber="{{ pendingActivity }}"
          viewStyle="color: #000"
          badgeStyle="background : red;color:#fff"
        ></app-badge>
      </a>
    </li>
    <li class="topbar-submenu">
      <a
        [pTooltip]="getUserName() + ' ' + generalTexts.profile.label"
        (click)="userProfile.toggle($event)"
        tooltipPosition="bottom"
        ><i class="pi pi-user"></i
      ></a>
    </li>
    <li>
      <div class="language-menu">
        <p-dropdown [options]="locales" [ngModel]="selectedLocale" dataKey="id" optionLabel="name"
          (onChange)="onLanguageChange($event)"></p-dropdown>
      </div>
    </li>
  </ul>

  <a
    type="button"
    (click)="toggleHeader($event)"
    class="toggle-header-button p-shadow-2 ng-star-inserted"
    [ngClass]="{ 'left-toggle': leftToggleBtn }"
    ><i class="pi" [ngClass]="getClass()"></i
  ></a>
</div>
<p-menu #userProfile [popup]="true" [model]="userMenu"> </p-menu>
<p-toast key="licence" position="top-center"></p-toast>
